import React, { useEffect, useState } from "react";
import professionalImage from "../images/professionalImage.png";
import { MdLogout } from "react-icons/md";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import swal from "sweetalert";
import api from "../../interceptors/axios";
import Cookies from "js-cookie";
import { format } from "date-fns";
import { styled } from "@mui/material/styles";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import defaultImg from "./../images/vjprofilepic.jpg" 

const StyledBadge = styled(Badge)(({ theme, state }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: state === "Active" ? "#44b700" : "red",
    color: state === "Active" ? "#44b700" : "red",
    boxShadow: `0 0 0 4px ${theme.palette.background.paper}`,
    width: 12,
    height: 12,
    borderRadius: "50%",
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const DashboardHeader = () => {
  const navigate = useNavigate();
  const fullName = Cookies.get("fullName");
  const role = Cookies.get("userRole");
  const lastLogin = Cookies.get("lastLogin");
  const state = Cookies.get("userState");
  const [loggingOut, setLoggingOut] = useState(false);

  const clearCookies = () => {
    document.cookie =
      "accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie =
      "refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  };

  const logout = async () => {
    try {
      setLoggingOut(true);
      const willUpdateStatus = await swal({
        title: "Are you sure you want to proceed?",
        buttons: true,
        icon: "warning",
        confirmButtonText: "Save",
        dangerMode: true,
        customClass: {
          container: "custom-swal-container",
          title: "custom-swal-title",
          confirmButton: "custom-swal-confirm-button",
        },
      });

      if (willUpdateStatus) {
        await api.post("/user/logout");
        clearCookies();
        Cookies.remove('userState');
        Cookies.remove("fullName");
        Cookies.remove("userRole");
        Cookies.remove("accessToken");
        Cookies.remove("refreshToken");
        Cookies.remove("lastLogin");
        Cookies.remove("isEntExcluded");
        Cookies.remove("code");
        swal("Success!", "Log out successful!", "success");
        navigate("/");
      }
    } catch (error) {
      console.error("Error updating status: ", error);
      swal("Error!", "Failed to update the status.", "error");
    } finally {
      setLoggingOut(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return format(date, "do 'of' MMMM yyyy | hh:mm a");
  };
  return (
    <header className="bg-white shadow-md p-4 flex justify-between items-center">
      <div className="flex items-center">
        <Stack direction="row" spacing={4}>
          {" "}
          <StyledBadge
            overlap="circular"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            variant="dot"
            state={state}
          >
            <Avatar
              alt="Vemy Sharp"
              src={defaultImg}
              sx={{ width: 80, height: 80 }}
            />{" "}
          </StyledBadge>
        </Stack>

        <div className="flex flex-col justify-start ml-5">
          <span className="text-md text-black font-sans">
            <span className="text-dark-blue"> Welcome {fullName}</span>
          </span>
          <div className="flex flex-row">
            <div className="mb-3 mt-2 mr-3">
              <span
                className="text-sm text-black shadow-md p-1.5 rounded-lg"
                style={{ backgroundColor: "#C0E1EE" }}
              >
                {role
                  ? role == 1
                    ? "Admin"
                    : role == 2
                    ? "Authorizer"
                    : role == 3
                    ? "Enterer"
                    : "Unknown Value"
                  : "Unknown Value"}
              </span>
            </div>
            <div className="mb-3 mt-2">
              <span
                className="text-sm text-black shadow-md p-1.5 rounded-lg"
                style={{
                  backgroundColor: state === "Active" ? "#44b700" : "red",
                  color: "white",
                }}
              >
                {state}
              </span>
            </div>
          </div>
          <span className="text-xs text-black">
            Last Login at: {lastLogin && formatDate(lastLogin)}
          </span>
        </div>
      </div>
      {/* <button className="bg-dark-blue p-3 mr-5 rounded-lg">
        <MdLogout className="text-white" onClick={()=>logout()} />
      </button> */}
      <button
        className="bg-dark-blue p-3 mr-5 rounded-lg"
        disabled={loggingOut}
      >
        {loggingOut ? (
          <div style={{ color: "white" }}>Logging Out...</div>
        ) : (
          <MdLogout className="text-white" onClick={logout} />
        )}
      </button>
    </header>
  );
};

export default DashboardHeader;
